export default "__VITE_ASSET__6KiHdZeS__"